export default "https://educa21-api.elabs.xyz";
